<template>
  <transition name="fade">
    <div
      v-if="form"
      class="scrollable_section"
    >
      <div class="">
        <section class="container loading-data">
          <div class="card card-no-shadow">
            <div class="card-header card-header-title">
              <div class="columns is-mobile is-gapless is-vcentered">
                <div class="column is-3">
                  <b-image
                    :src="require('@/assets/logo.svg')"
                    alt="qlipmark"
                    class="logo"
                  />
                </div>
                <div class="column is-flex-grow-0 has-text-primary logo-text">
                  qlipmark
                </div>
              </div>
            </div>
            <div class="card-content bookmark-card-form pt-2">
              <form
                @submit.prevent="onSubmit"
                @reset="onReset"
              >
                <div class="columns is-vcentered is-mobile my-0 edit-columns">
                  <time
                    class="column pt-0 pb-2 card-date"
                    :datetime="$formatDate(form.updatedAt)"
                  >
                    {{ $formatDate(form.updatedAt) }}
                  </time>
                  <div class="column pt-0 pb-2 has-text-right">
                    <b-button
                      v-if="!isEditingAll && hasValidUrl"
                      type="is-light is-stealth"
                      class="edit-all"
                      @click="editAll"
                    >
                      edit
                    </b-button>
                  </div>
                </div>

                <b-field
                  v-if="isEditingUrl"
                  label="url"
                  label-position="inside"
                >
                  <b-input
                    ref="urlInput"
                    v-model="form.url"
                    :loading="loading"
                    required
                  />
                </b-field>
                <div
                  v-else
                  @click="editUrl"
                >
                  <div class="preview url">
                    <img
                      v-if="form.faviconUrl"
                      :src="form.faviconUrl"
                      class="favicon"
                      @error="setPlaceholder"
                    >

                    {{ form.url }}
                  </div>
                </div>

                <div
                  v-if="hasValidUrl"
                  class="columns is-mobile is-vcentered"
                >
                  <div
                    v-if="form.imageUrl || isEditingImage"
                    class="column is-4"
                    @click="editImage"
                  >
                    <b-image
                      :src="form.imageUrl"
                      class="bookmark-image"
                      ratio="6by4"
                    />
                  </div>
                  <div class="column">
                    <b-field
                      v-if="isEditingTitle"
                      label="title"
                      label-position="inside"
                      class="title-field"
                    >
                      <b-input
                        v-model="form.title"
                        :loading="loading"
                      />
                    </b-field>
                    <div
                      v-else
                      @click="editTitle"
                    >
                      <div
                        v-if="form.title == ''"
                        class="preview blank"
                      >
                        &#x3C;add title&#x3E;
                      </div>
                      <div
                        v-else
                        class="preview title"
                      >
                        {{ form.title }}
                      </div>
                    </div>

                    <b-field
                      v-if="isEditingDescription"
                      label="description"
                      label-position="inside"
                      class="description-field"
                    >
                      <b-input
                        v-model="form.description"
                        type="textarea"
                        :loading="loading"
                      />
                    </b-field>
                    <div
                      v-else
                      @click="editDescription"
                    >
                      <div
                        v-if="form.description == ''"
                        class="preview blank"
                      >
                        &#x3C;add description&#x3E;
                      </div>
                      <div
                        v-else
                        class="preview description"
                      >
                        {{ form.description }}
                      </div>
                    </div>
                  </div>
                </div>


                <div
                  v-if="hasValidUrl"
                  class="field is-floating-in-label tags-holder"
                >
                  <div class="label">
                    Tags
                  </div>
                  <TagInput
                    placeholder="Add some tags"
                    :selected-tags="form.tagList"
                    :all-tags-names="allTagsNames"
                    :allow-new="true"
                    autofocus
                    @input="setSelectedTags"
                    @tagClicked="addTag"
                    @submit="onSubmit"
                  />

                  <TagList
                    label="Suggested:"
                    :tags="form.suggestedTags"
                    :existingTags="allTagsNames"
                    :selected-tags="form.tagList"
                    @tagClicked="addTag"
                  />
                </div>

                <nav
                  v-show="!loading"
                  class=""
                >
                  <b-button
                    type="is-primary"
                    tag="input"
                    native-type="submit"
                    expanded
                    :value="saveLabel"
                    @click.prevent="onSubmit"
                  />
                </nav>
              </form>
            </div>
          </div>
        </section>

        <SelectImage
          ref="selectImage"
          :is-choose-image-active="isChooseImageActive"
          :all-images="allImages"
          @changeImage="changeImage"
        />
      </div>
    </div>
  </transition>
</template>

<script>
  import Vue from 'vue'
  import { apolloClient } from '@/graphql/apollo'
  import { GET_ALL_TAGS_NO_PAGE_QUERY } from '@/graphql/queries/tags'
  import { DEFAULT_BOOKMARK_FORM_VALUES } from '@/graphql/queries/bookmarks'
  import { formMixin } from '@/mixins/crud/form'
  import { mapGetters, mapActions } from 'vuex'
  import { ToastProgrammatic as Toast } from 'buefy'
  import _ from 'lodash'
  import Pluralize from 'pluralize';
  import TagInput from '@/qlipmark-shared/components/tags/TagInput.vue'
  import TagList from '@/qlipmark-shared/components/tags/TagList.vue'
  import SelectImage from '@/qlipmark-shared/components/SelectImage.vue'

  export default {
    name: 'BookmarkForm',
    mixins: [ formMixin('bookmark') ],
    components: {
      TagInput,
      TagList,
      SelectImage
    },
    props: ['url', 'modal'],
    data: function() {
      return {
        loading: false,
        prevUrl: '',
        allTagsNames: [],
        form: Object.assign({}, this.bookmark),
        hasValidUrl: false,
        isEditingUrl: true,
        isEditingImage: false,
        isEditingTitle: false,
        isEditingDescription: false,
        isChooseImageActive: false
      }
    },
    computed: {
      ...mapGetters({
        bookmarkById: 'bookmarks/byId',
        bookmarkByUrl: 'bookmarks/byUrl',
        tags: 'tags/all',
        tagsById: 'tags/byId'
      }),
      bookmark() {
        return this.bookmarkById(this.id)
      },
      // allTagsNames() {
      //   return this.tags.map(tag => tag.name)
      // },
      saveLabel() {
        let label = this.form.id ? 'Update' : 'Save'
        if (!this.hasValidUrl) {
          label = "Parse"
        }

        return label
      },
      allImages() {
        return this.form.images
      },
      isEditingAll() {
        return this.isEditingUrl && this.isEditingImage && this.isEditingTitle && this.isEditingDescription
      }
    },
    watch: {
      bookmark() {
        if (this.id) {
          this.form = Object.assign({}, this.bookmark)
          if (this.bookmark.tags) {
            this.$set(this.form, 'tagList', this.bookmark.tags.map(tag => {
                if (this.tagsById(tag) != undefined) {
                  return this.tagsById(tag).name
                }
              })
            )
          }
        }
      }
    },
    beforeMount() {
      let vm = this
      if (this.id) {
        this.loadById(this.id).then(function(response){
          if (!response) {
            vm.$router.push({name: 'NotFound'})
          }
        })
      } else {
        this.onReset()
      }
    },
    mounted() {
      // this.loadAllTags({limit: 0})
      let vm = this
      apolloClient.query({ query: GET_ALL_TAGS_NO_PAGE_QUERY,
                           fetchPolicy: 'cache-first' })
      .then(response => {
        vm.allTagsNames = response.data.tags.collection.map(tag => tag.name)
      })
      // this.allTags = response

      if (!this.id) {
        this.form.url = this.$route.query.url ? this.$route.query.url : this.url

        if (this.form.url != '') {
          this.urlChanged()
        } else {
          this.isEditingUrl = true
          this.$refs.urlInput.focus()
        }
      } else {
        this.isEditingUrl = false
        this.hasValidUrl = true
      }
    },
    methods: {
      ...mapActions({
        loadAllTags: 'tags/loadAllNoPage',
      }),
      loadByUrl(args) {
        return this.$store.dispatch('bookmarks/loadByUrl', args)
      },
      editUrl() {
        this.isEditingUrl = true
      },
      editTitle() {
        this.isEditingTitle = true
      },
      editDescription() {
        this.isEditingDescription = true
      },
      editImage() {
        // this.isChooseImageActive = true
        this.$refs.selectImage.open()
      },
      changeImage(url) {
        this.form.imageUrl = url
        this.isChooseImageActive = false
      },
      urlFocus() {
        this.prevUrl = this.form.url
      },
      urlBlur() {
        if (this.form.url != '' && this.prevUrl != this.form.url && !this.id) {
          this.urlChanged()
        }

        this.prevUrl = this.form.url
      },
      urlChanged() {
        if (this.form.url && this.validURL(this.form.url)) {
          let vm = this
          this.loading = true
          this.isEditingUrl = false
          this.loadByUrl({url: this.form.url, parse: 'true'}).then(function(response) {
            if (response) {
              if (response.data.bookmark) {
                const bookmark = response.data.bookmark
                bookmark.suggestedTags = bookmark.suggestedTags.map((entry)=>{
                  const singular = Pluralize(entry.toLowerCase(), 1) 
                  if(vm.allTagsNames.indexOf(singular) >= 0) {
                    return singular
                  }
                  const plural = Pluralize(entry.toLowerCase(), 2) 
                  if(vm.allTagsNames.indexOf(plural) >= 0) {
                    return plural
                  }
                  return entry
                })
                vm.form = Object.assign({}, bookmark)
              }
              vm.hasValidUrl = true
              vm.loading = false
            }
          })
        } else if (this.form.url && !this.validURL(this.form.url)) {
          Toast.open({
            message: 'Invalid URL',
            position: 'is-bottom',
            type: 'is-warning'
          })
        } else if (this.form.url == "") {
          Toast.open({
            message: 'No URL on clipboard',
            position: 'is-bottom',
            type: 'is-light'
          })
        }
      },
      addTag(tag) {
        if (!Array.isArray(tag)) {
          tag = tag.split(',')[0]
          if (this.form.tagList.includes(tag)) {
            const index = this.form.tagList.indexOf(tag);
            this.form.tagList.splice(index, 1);
          } else {
            this.$set(this.form, 'tagList', this.form.tagList.concat(tag))
          }
        } else {
          this.$set(this.form, 'tagList', this.form.tagList.push(tag))
        }
      },
      setSelectedTags(value) {
        this.$set(this.form, 'tagList', value)
      },
      onSubmit() {
        if (this.hasValidUrl) {
          const sanitizedForm = _.pick(this.form, _.keys(DEFAULT_BOOKMARK_FORM_VALUES))
          let vm = this
          this.save({id: parseInt(sanitizedForm.id), form: sanitizedForm}).then(function(response){
            if (response) {
              // const responseId = response.data.bookmarks.id
              if (vm.modal) {
                vm.$emit('close')
              } else {
                vm.$router.push({name: 'BookmarkSuccess'})
              }
              vm.$emit('edited', {id: sanitizedForm.id});
            }
          })
        } else {
          this.urlChanged()
        }
      },
      onReset() {
        Vue.set(this, 'form', JSON.parse(JSON.stringify(DEFAULT_BOOKMARK_FORM_VALUES)))
        // this.form = Object.assign({}, this.bookmark)
      },
      validURL(str) {
        var pattern = new RegExp('^(https?:\\/\\/)?'+ // protocol
          '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|'+ // domain name
          '((\\d{1,3}\\.){3}\\d{1,3}))'+ // OR ip (v4) address
          '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*'+ // port and path
          '(\\?[;&a-z\\d%_.~+=-]*)?'+ // query string
          '(\\#[-a-z\\d_]*)?$','i'); // fragment locator
        return !!pattern.test(str);
      },
      editAll() {
        this.isEditingUrl = true
        this.isEditingImage = true
        this.isEditingTitle = true
        this.isEditingDescription = true
      },
      setPlaceholder(e) {
        e.target.classList.add('placeholder')
        e.target.src = "/images/defaults/globe-americas-solid.svg"
      },
    },
  }
</script>

<style lang="scss" scoped>
  .bookmarkform-modal {
    max-width: 720px;
    margin: 0 auto;
  }
</style>
